module.exports = __webpack_public_path__ + "static/img/bg_finish.2aa566fe.svg";